// Given some time might be computing whether a user has a session due, we evaluate whether cards are due using a date slightly shifted into the future, to find the cards that'd be due on that conceptual day.
export default (nowMillis: number): number => nowMillis + 1000 * 60 * 60 * 16; // 16 hour lookahead
